import { fetch } from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'

/**
 * @param {Object} data
 * 获取项目列表
 */
export function getProjectList(data) {
  return fetch ({
    url: '/maintain/project/pageList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 获取单位列表
 */
export function getUnitSimpleList(data) {
  return fetch ({
    url: '/auth/subPlatform/propertyUnit/simpleList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 获取部门列表
 */
export function getDepartmentList(params) {
  return fetch ({
    url: '/auth/subPlatform/department/simpleList',
    method: 'GET',
    params
  })
}


/**
 * @param {Object} data
 * 添加项目
 */
export function addProject(data) {
  return fetch({
    url: '/maintain/project/save',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 导出项目
 */
export function exportProject(data) {
  return formAxios({
    url: '/maintain/project/exportList',
    method: 'POST',
    data
  })
}




/**
 * @param {Object} data
 * 删除项目
 */
export function deleteProject(data) {
  return fetch({
    url: '/maintain/project/delete',
    method: 'POST',
    data
  })
}



/**
 * @param {Object} params
 * 根据部门id获取部门详情
 */
export function getProjectDetail(params) {
  return fetch({
    url: '/maintain/project/detail',
    method: 'GET',
    params
  })
}




// WEBPACK FOOTER //
// ./src/api/ProjectManagement/index.js